/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Onenote_TitleInputs */

const en_features_onenote_title = /** @type {(inputs: Features_Onenote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take notes with one click`)
};

const es_features_onenote_title = /** @type {(inputs: Features_Onenote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma notas con un clic`)
};

/**
* | output |
* | --- |
* | "Take notes with one click" |
*
* @param {Features_Onenote_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_onenote_title = /** @type {((inputs?: Features_Onenote_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Onenote_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_onenote_title(inputs)
	return en_features_onenote_title(inputs)
});